var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MonthSelector',{staticClass:"ma-2",on:{"select":_vm.selectMonth}}),_c('ListProducts',{attrs:{"products":_vm.products,"users":_vm.users,"outs":_vm.outs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }